import { createElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RedirectIfAuth } from '@/app/router/ProtectedRoute';
import LoginPage from '@/pages/login';
import NotFoundPage from '@/pages/not-found';

export const publicRoutes: RouteObject[] = [
  { path: '/login', element: createElement(RedirectIfAuth, null, LoginPage) },
  { path: '*', element: NotFoundPage },
];
